import type { DocPageContent } from '../docs-content'

const page = {
  order: 9,
  slug: 'source-monitor',
  title: '源监视器工作流程',
  description: '预览源媒体、标记入/出点、插入和覆盖。',
  category: '核心编辑',
  sections: [
    {
      title: '打开并预览源媒体',
      items: [
        '从媒体面板或媒体信息中打开媒体。',
        '在放置到时间线之前预览源素材。',
        '独立于时间线预览使用源播放控制。',
      ],
    },
    {
      title: '标记范围',
      items: [
        '设置"标记入点"和"标记出点"以定义源范围。',
        '当需要再次使用完整源素材时清除入/出点。',
        '在以键盘为主的操作中使用快捷键 I、O 和 Alt+X。',
      ],
    },
    {
      title: '编辑到时间线',
      items: [
        '使用"插入"编辑将标记范围放入并推动后续素材。',
        '使用"覆盖"编辑替换目标位置的时间线素材。',
        '使用修补目标控制哪些时间线轨道接收源媒体。',
      ],
    },
  ],
} satisfies DocPageContent

export default page